<template>
	<div>
		<el-dialog
			width="70%"
			title="Visualização de campanha"
			:visible.sync="openPreviewInfo"
			:close-on-click-modal="false"
			:center="true"
			:lock-scroll="false"
		>
			<div class="main-container">
				
				<div class="md-layout">
					<div
						class="md-layout-item md-small-size-100 md-medium-size-100 md-large-size-100 md-xlarge-size-100"
					>
						<h2 style="margin: 0;">{{ campaign.name }}</h2>
					</div>
					<div
						class="md-layout-item md-small-size-100 md-medium-size-100 md-large-size-100 md-xlarge-size-100"
					>
						<h5 style="display: inline-block">
							{{ new Date(campaign.start_date).toLocaleDateString("pt-BR") }} às {{ campaign.start_time.slice(0,-3) }}
						</h5>
						&nbsp;
						<i class="fa fa-circle" style="display: inline-block;"></i>
						&nbsp;
						<h5 style="display: inline-block">
							{{ new Date(campaign.end_date).toLocaleDateString("pt-BR") }} às {{ campaign.end_time.slice(0,-3) }}
						</h5>
					</div>
					<div
						class="md-layout-item md-small-size-100 md-medium-size-100 md-large-size-100 md-xlarge-size-100"
					>
						<template v-if="campaign.expired === 1">
							<i style="color:#ef6b6c" class="fas fa-circle"></i>&nbsp;
							<span style="color:#ef6b6c">FINALIZADA</span>
						</template>
						<template v-else-if="campaign.current === 1">
							<i style="color:#4baf51" class="fas fa-circle"></i>&nbsp;
							<span style="color:#4baf51">ABERTA</span>
						</template>
						<template v-else-if="campaign.opened === 0">
							<i style="color:#c9cacb" class="fas fa-circle"></i>&nbsp;
							<span style="color:#c9cacb">PRÓXIMA</span>
						</template>
					</div>
					<div
						class="md-layout-item md-size-100"
					>
						<Spinner v-if="loading"/>
						<div class="md-layout" v-else>
							<h4 class="md-layout-item md-size-100" style="padding: 0;">Banners cadastrados</h4>
							<div class="table-wrapper md-layout-item md-size-100">
								<el-table
									style="padding: 0;"
									class="md-size-100"
									:data="banners"
								>
								<el-table-column
									prop="name"
									label="Nome"
								>
								</el-table-column>
								<el-table-column
									prop="position"
									label="Área"
								>
								</el-table-column>
								<el-table-column label="URL">
									<template slot-scope="scope">
										<div class="url-ellipsis">{{ scope.row.url }}</div>
									</template>
								</el-table-column>
								<el-table-column width="260">
									<template slot-scope="scope">
										<div class="banner-action-cell">
											<el-button
												icon="el-icon-view"
												round
												type="primary"
												class="banner-action-btn"
												@click="showBannerPopup(scope.row)"
											>
												Visualizar banner
											</el-button>
										</div>
									</template>
								</el-table-column>
								</el-table>
							</div>
							<div
								v-if="canUsePreRollFeature"
								class="md-layout-item md-size-100"
								style="padding: 0; margin-top: 24px;"
							>
								<h4 style="margin-top: 0;">Áudios pre-roll</h4>
								<p v-if="showPreRollAdminWarning" class="pre-roll-admin-warning">
									<i class="fas fa-exclamation-triangle"></i>
									Aviso: a FF
									<code>features.mobadsPreRoll</code>
									não está ativa no
									<code>custom_json</code>
									da rádio. Como admin, você ainda pode visualizar pre-roll.
								</p>
								<p v-if="preRollForbidden" style="color: #c0392b;">
									Áudios pre-roll indisponíveis para esta rádio.
								</p>
								<p v-if="!preRollForbidden && !preRollAudios.length" style="color: #7a7a7a;">
									Nenhum áudio pre-roll cadastrado para esta campanha.
								</p>
								<div v-else class="table-wrapper md-layout-item md-size-100">
									<el-table
										style="padding: 0;"
										class="md-size-100"
										:data="preRollAudios"
									>
									<el-table-column prop="name" label="Nome"></el-table-column>
									<el-table-column width="260">
										<template slot-scope="scope">
											<div class="audio-action-cell">
												<el-button
													round
													type="primary"
													class="audio-action-btn"
													@click="togglePreRollPreview(scope.row.url)"
												>
													<i
														:class="
															isPreRollPlaying(scope.row.url)
																? 'fas fa-pause'
																: 'fas fa-play'
														"
														style="margin-right: 6px"
													></i>
													{{ isPreRollPlaying(scope.row.url) ? "Pause" : "Play" }}
												</el-button>
											</div>
										</template>
									</el-table-column>
									</el-table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { Dialog, Button } from "element-ui";
import Spinner from '../../../components/Icons/Spinner.vue'
import models from '../../../routes/models';
import Swal from "sweetalert2";
import jwt_decode from "jwt-decode";
import canUsePreRoll from "../../../utils/canUsePreRoll";
export default {
	name: "ViewInfo",
	components: {
		[Button.name]: Button,
		[Dialog.name]: Dialog,
		Spinner
	},
	data() {
		return {
			openPreviewInfo: false,
			radio: jwt_decode(localStorage.getItem("APP_01")).radio,
			user: jwt_decode(localStorage.getItem("SET_APP")).user[0],
			campaign: {},
			banners: [],
			loading: false,
			preRollForbidden: false,
			preRollAudioPlayer: null,
			currentPlayingPreRollSource: null
		};
	},

	methods: {
		parsePreRollAudios(preRollRawValue) {
			if (!preRollRawValue) return []
			let parsedValue = preRollRawValue
			if (typeof preRollRawValue === "string") {
				try {
					parsedValue = JSON.parse(preRollRawValue)
				} catch {
					return []
				}
			}
			if (!Array.isArray(parsedValue)) return []
			return parsedValue
				.filter((audio) => audio && (audio.url || audio.name))
				.map((audio) => ({
					name: audio.name || "",
					url: audio.url || "",
				}))
		},
		showBannerPopup(banner) {
			Swal.fire({
				title: "Visualização de banner",
				html: `
					<h3>Nome: ${banner.name}</h3>
					<h5>Posição: ${banner.position}</h5>
					<div style="background: #e3e3e3">
						<img src=${banner.image} width=300>
					</div>
				    `,
				showCloseButton: true
			});
		},
		isPreRollPlaying(source) {
			return (
				!!source &&
				this.currentPlayingPreRollSource === source &&
				this.preRollAudioPlayer &&
				!this.preRollAudioPlayer.paused
			)
		},
		togglePreRollPreview(source) {
			if (!source) return
			if (!this.preRollAudioPlayer) {
				this.preRollAudioPlayer = new Audio()
				this.preRollAudioPlayer.onended = () => {
					this.currentPlayingPreRollSource = null
				}
			}
			if (this.currentPlayingPreRollSource === source && !this.preRollAudioPlayer.paused) {
				this.preRollAudioPlayer.pause()
				this.currentPlayingPreRollSource = null
				return
			}
			this.preRollAudioPlayer.src = source
			this.preRollAudioPlayer.play()
			this.currentPlayingPreRollSource = source
		},
		stopPreRollPreview() {
			if (this.preRollAudioPlayer) {
				this.preRollAudioPlayer.pause()
			}
			this.currentPlayingPreRollSource = null
		},
		isForbiddenError(error) {
			return Number(error && error.response && error.response.status) === 403
		},
		showPreRollForbiddenWarning() {
			Swal.fire({
				title: "Funcionalidade indisponível",
				html: "A visualização de áudios pre-roll não está habilitada para esta rádio.",
				type: "warning",
			})
		},
		getAudioPreRolls(idMobAd) {
			return models().get(`mobads/getAudioPreRolls?idMobAd=${idMobAd}`);
		}
	},

	mounted() {
		this.$root.$on("mobadsRadioConfigUpdated", (radioPayload) => {
			if (!radioPayload) return
			this.radio = {
				...this.radio,
				...radioPayload,
			}
		})
		this.$root.$on("openPreviewCampaign", payload => {
			this.campaign = {
				...payload,
				preRollAudios: this.canUsePreRollFeature
					? this.parsePreRollAudios(
						payload.preRollAudios || payload.pre_roll_audios
					)
					: [],
			};
			this.openPreviewInfo = true;
			this.loading = true
			this.preRollForbidden = false
			this.stopPreRollPreview()
			const bannersRequest = models().get(`mobads/getBanners?idMobAd=${payload.id}`)
			const preRollsRequest = this.canUsePreRollFeature
				? this.getAudioPreRolls(payload.id).catch((error) => {
					if (this.isForbiddenError(error)) {
						this.preRollForbidden = true
						this.showPreRollForbiddenWarning()
						return { data: [] }
					}
					throw error
				})
				: Promise.resolve({ data: [] })
			Promise.all([bannersRequest, preRollsRequest])
				.then(([banners, preRolls]) => {
					this.banners = []
					for (let item of banners.data) {
						this.banners.push({
							idCampaign: item.campaign_id,
							idBannerType: item.banner_type_id,
							idZone: item.zone_id,
							image: item.url_image,
							name: item.name,
							type: item.type,
							url: item.url_image_click,
							position: item.zone,
							hash: item.hash ? item.hash : ""
						});
					}

					this.banners.sort((a, b) => {
						if (a.name < b.name) {
							return -1
						}
						if (a.name > b.name) {
							return 1
						}
						return 0
					})

					const preRollItems = Array.isArray(preRolls.data) ? preRolls.data : []
					this.campaign = {
						...this.campaign,
						preRollAudios: this.parsePreRollAudios(
							preRollItems
						),
					}

					this.loading = false
				})
				.catch(() => {
					this.loading = false
				});
		});
	}
	,
	computed: {
		preRollAccess() {
			return canUsePreRoll({
				user: this.user,
				radio: this.radio,
			})
		},
		canUsePreRollFeature() {
			return this.preRollAccess.canUse
		},
		showPreRollAdminWarning() {
			return this.preRollAccess.isAdmin && !this.preRollAccess.isFeatureEnabledForRadio
		},
		preRollAudios() {
			return this.campaign.preRollAudios || []
		}
	},
	watch: {
		openPreviewInfo(value) {
			if (!value) {
				this.stopPreRollPreview()
			}
		}
	}
};
</script>

<style scoped>
.main-container {
	min-height: 750px;
}

.url-redirect-box {
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}

.table-wrapper {
	overflow-x: auto;
}

.banner-action-cell {
	display: flex;
	align-items: center;
	justify-content: flex-end;
}

.banner-action-btn {
	min-width: 180px;
}

.url-ellipsis {
	max-width: 320px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.audio-action-cell {
	display: flex;
	align-items: center;
	justify-content: flex-end;
}

.audio-action-btn {
	min-width: 180px;
}

.pre-roll-admin-warning {
	margin: 0 0 12px 0;
	padding: 10px 12px;
	border-radius: 6px;
	background: #fff9db;
	border: 1px solid #ffe08a;
	color: #5f4b00;
	font-size: 13px;
}

.pre-roll-admin-warning code {
	background: #f7efc2;
	padding: 1px 4px;
	border-radius: 4px;
}
</style>
